import * as React from 'react';
import {
    Box,
    Grid,
    Button,
    TextField,
    Snackbar,
    Alert,
    Typography,
    FormControl,
    MenuItem,
    Card,
    CardContent,
    FormControlLabel,
    Checkbox,
    FormHelperText,
    Radio,
    RadioGroup,
    Paper,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Modal
} from '@mui/material';

import LoadingButton from '@mui/lab/LoadingButton';
import SaveIcon from '@mui/icons-material/Save';

import {
    Autocomplete,
} from '@mui/material';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    // border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

export const StudentDetailsComp = (props) => {

    return (
        <Box>

            {/* HEADER */}
            <Box mb={3}>
                <Typography
                    variant="h5"
                    sx={{
                        fontWeight: 700,
                        color: '#042740'
                    }}
                >
                    Student Details
                </Typography>

                <Typography
                    variant="body2"
                    color="text.secondary"
                >
                    Manage Student profile, application progress, documentation, and deployment status
                </Typography>
            </Box>

            {/* PERSONAL DETAILS */}
            <Card sx={{ mb: 3, borderRadius: 3 }}>
                <CardContent>

                    <Typography
                        variant="h6"
                        sx={{
                            mb: 3,
                            color: '#042740',
                            fontWeight: 600
                        }}
                    >
                        Personal Information
                    </Typography>

                    <Grid container spacing={2}>

                        {/* First Name */}
                        <Grid item xs={12} md={4}>
                            <TextField
                                fullWidth
                                label="First Name"
                                value={props.LeadFormData.txtFirstName || ''}
                                error={!!props.LeadFormData.txtFirstNameErr}
                                onChange={(e) =>
                                    props.HandleInputs(e, 'txtFirstName')
                                }
                            />
                            <FormHelperText sx={{ color: '#d32f2f' }}>
                                {props.LeadFormData.txtFirstNameErr}
                            </FormHelperText>
                        </Grid>

                        {/* Last Name */}
                        <Grid item xs={12} md={4}>
                            <TextField
                                fullWidth
                                label="Last Name"
                                value={props.LeadFormData.txtLastName || ''}
                                error={!!props.LeadFormData.txtLastNameErr}
                                onChange={(e) =>
                                    props.HandleInputs(e, 'txtLastName')
                                }
                            />
                            <FormHelperText sx={{ color: '#d32f2f' }}>
                                {props.LeadFormData.txtLastNameErr}
                            </FormHelperText>
                        </Grid>

                        {/* DOB */}
                        <Grid item xs={12} md={4}>
                            <TextField
                                type="date"
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                label="Date Of Birth"
                                value={props.LeadFormData.txtDOB || ''}
                                error={!!props.LeadFormData.txtDOBErr}
                                onChange={(e) =>
                                    props.HandleInputs(e, 'txtDOB')
                                }
                            />
                            <FormHelperText sx={{ color: '#d32f2f' }}>
                                {props.LeadFormData.txtDOBErr}
                            </FormHelperText>
                        </Grid>

                        {/* Age */}
                        <Grid item xs={12} md={2}>
                            <TextField
                                fullWidth
                                label="Age"
                                value={props.LeadFormData.txtAge || ''}
                                disabled
                            />
                        </Grid>

                        {/* Qualification */}
                        <Grid item xs={12} md={3}>
                            <TextField
                                select
                                fullWidth
                                label="Qualification"
                                value={props.LeadFormData.ddlQualification || ''}
                                error={!!props.LeadFormData.ddlQualificationErr}
                                onChange={(e) =>
                                    props.HandleInputs(e, 'ddlQualification')
                                }
                            >
                                <MenuItem value="GNM">GNM</MenuItem>
                                <MenuItem value="BSc Nursing">
                                    BSc Nursing
                                </MenuItem>
                                <MenuItem value="Post Basic Nursing">
                                    Post Basic Nursing
                                </MenuItem>
                                <MenuItem value="MSc Nursing">
                                    MSc Nursing
                                </MenuItem>
                                <MenuItem value="PhD Nursing">
                                    PhD Nursing
                                </MenuItem>
                            </TextField>

                            <FormHelperText sx={{ color: '#d32f2f' }}>
                                {props.LeadFormData.ddlQualificationErr}
                            </FormHelperText>
                        </Grid>

                        {/* Marital Status */}
                        <Grid item xs={12} md={3}>
                            <TextField
                                select
                                fullWidth
                                label="Marital Status"
                                value={props.LeadFormData.ddlMaritalStatus || ''}
                                error={!!props.LeadFormData.ddlMaritalStatusErr}
                                onChange={(e) =>
                                    props.HandleInputs(e, 'ddlMaritalStatus')
                                }
                            >
                                <MenuItem value="Single">Single</MenuItem>
                                <MenuItem value="Married">Married</MenuItem>
                            </TextField>

                            <FormHelperText sx={{ color: '#d32f2f' }}>
                                {props.LeadFormData.ddlMaritalStatusErr}
                            </FormHelperText>
                        </Grid>

                        {/* Kids Count */}
                        {
                            props.LeadFormData.ddlMaritalStatus === 'Married' && (

                                <Grid item xs={12} md={2}>
                                    <TextField
                                        fullWidth
                                        label="Kids Count"
                                        value={props.LeadFormData.txtKidsCount || ''}
                                        error={!!props.LeadFormData.txtKidsCountErr}
                                        onChange={(e) =>
                                            props.HandleInputs(e, 'txtKidsCount')
                                        }
                                    />

                                    <FormHelperText sx={{ color: '#d32f2f' }}>
                                        {props.LeadFormData.txtKidsCountErr}
                                    </FormHelperText>
                                </Grid>

                            )
                        }

                    </Grid>

                </CardContent>
            </Card>

            {/* CONTACT DETAILS */}
            <Card sx={{ mb: 3, borderRadius: 3 }}>
                <CardContent>

                    <Typography
                        variant="h6"
                        sx={{
                            mb: 3,
                            color: '#042740',
                            fontWeight: 600
                        }}
                    >
                        Contact Information
                    </Typography>

                    <Grid container spacing={2}>

                        {/* Contact Number */}
                        <Grid item xs={12} md={4}>
                            <TextField
                                fullWidth
                                label="Contact Number"
                                value={props.LeadFormData.txtContactNumber || ''}
                                error={!!props.LeadFormData.txtContactNumberErr}
                                onChange={(e) =>
                                    props.HandleInputs(e, 'txtContactNumber')
                                }
                            />
                            <FormHelperText sx={{ color: '#d32f2f' }}>
                                {props.LeadFormData.txtContactNumberErr}
                            </FormHelperText>
                        </Grid>

                        {/* Whatsapp Number */}
                        <Grid item xs={12} md={4}>
                            <TextField
                                fullWidth
                                label="Whatsapp Number"
                                value={props.LeadFormData.txtWhatsappNumber || ''}
                                error={!!props.LeadFormData.txtWhatsappNumberErr}
                                onChange={(e) =>
                                    props.HandleInputs(e, 'txtWhatsappNumber')
                                }
                            />
                            <FormHelperText sx={{ color: '#d32f2f' }}>
                                {props.LeadFormData.txtWhatsappNumberErr}
                            </FormHelperText>
                        </Grid>

                        {/* Email */}
                        <Grid item xs={12} md={4}>
                            <TextField
                                fullWidth
                                label="Email"
                                value={props.LeadFormData.txtEmail || ''}
                                error={!!props.LeadFormData.txtEmailErr}
                                onChange={(e) =>
                                    props.HandleInputs(e, 'txtEmail')
                                }
                            />
                            <FormHelperText sx={{ color: '#d32f2f' }}>
                                {props.LeadFormData.txtEmailErr}
                            </FormHelperText>
                        </Grid>

                        {/* Permanent Address */}
                        <Grid item xs={12} md={6}>
                            <TextField
                                fullWidth
                                multiline
                                rows={3}
                                label="Permanent Address"
                                value={props.LeadFormData.txtPermanentAddress || ''}
                                error={!!props.LeadFormData.txtPermanentAddressErr}
                                onChange={(e) =>
                                    props.HandleInputs(e, 'txtPermanentAddress')
                                }
                            />
                            <FormHelperText sx={{ color: '#d32f2f' }}>
                                {props.LeadFormData.txtPermanentAddressErr}
                            </FormHelperText>
                        </Grid>

                        {/* Current Address */}
                        <Grid item xs={12} md={6}>
                            <TextField
                                fullWidth
                                multiline
                                rows={3}
                                label="Current Address"
                                value={props.LeadFormData.txtCurrentAddress || ''}
                                error={!!props.LeadFormData.txtCurrentAddressErr}
                                onChange={(e) =>
                                    props.HandleInputs(e, 'txtCurrentAddress')
                                }
                            />
                            <FormHelperText sx={{ color: '#d32f2f' }}>
                                {props.LeadFormData.txtCurrentAddressErr}
                            </FormHelperText>
                        </Grid>

                        {/* Guardian Number */}
                        <Grid item xs={12} md={4}>
                            <TextField
                                fullWidth
                                label="Guardian Number"
                                value={props.LeadFormData.txtGuardianNumber || ''}
                                error={!!props.LeadFormData.txtGuardianNumberErr}
                                onChange={(e) =>
                                    props.HandleInputs(e, 'txtGuardianNumber')
                                }
                            />
                            <FormHelperText sx={{ color: '#d32f2f' }}>
                                {props.LeadFormData.txtGuardianNumberErr}
                            </FormHelperText>
                        </Grid>

                    </Grid>

                </CardContent>
            </Card>

            {/* EXPERIENCE & GERMAN DETAILS */}
            <Card sx={{ mb: 3, borderRadius: 3 }}>
                <CardContent>

                    <Typography
                        variant="h6"
                        sx={{
                            mb: 3,
                            color: '#042740',
                            fontWeight: 600
                        }}
                    >
                        Experience & German Details
                    </Typography>

                    <Grid container spacing={2}>

                        {/* Experience */}

                        <Grid item xs={12} md={4}>
                            <TextField
                                select
                                fullWidth
                                label="Total Experience"
                                value={props.LeadFormData.ddlExperience || ''}
                                error={!!props.LeadFormData.ddlExperienceErr}
                                onChange={(e) =>
                                    props.HandleInputs(e, 'ddlExperience')
                                }
                            >
                                <MenuItem value="Fresher">
                                    Fresher
                                </MenuItem>

                                <MenuItem value="0-2 Years">
                                    0-2 Years
                                </MenuItem>

                                <MenuItem value="2-5 Years">
                                    2-5 Years
                                </MenuItem>

                                <MenuItem value="More Than 5 Years">
                                    More Than 5 Years
                                </MenuItem>
                            </TextField>

                            <FormHelperText sx={{ color: '#d32f2f' }}>
                                {props.LeadFormData.ddlExperienceErr}
                            </FormHelperText>
                        </Grid>

                        {/* Started German */}

                        <Grid item xs={12} md={4}>
                            <TextField
                                select
                                fullWidth
                                label="Started Learning German?"
                                value={props.LeadFormData.ddlStartedGerman || ''}
                                error={!!props.LeadFormData.ddlStartedGermanErr}
                                onChange={(e) =>
                                    props.HandleInputs(e, 'ddlStartedGerman')
                                }
                            >
                                <MenuItem value="Yes">
                                    Yes
                                </MenuItem>

                                <MenuItem value="No">
                                    No
                                </MenuItem>
                            </TextField>

                            <FormHelperText sx={{ color: '#d32f2f' }}>
                                {props.LeadFormData.ddlStartedGermanErr}
                            </FormHelperText>
                        </Grid>

                        {/* German Level */}

                        {
                            props.LeadFormData.ddlStartedGerman === 'Yes' && (

                                <Grid item xs={12} md={4}>
                                    <TextField
                                        select
                                        fullWidth
                                        label="German Level"
                                        value={props.LeadFormData.ddlGermanLevel || ''}
                                        error={!!props.LeadFormData.ddlGermanLevelErr}
                                        onChange={(e) =>
                                            props.HandleInputs(e, 'ddlGermanLevel')
                                        }
                                    >
                                        <MenuItem value="A1">A1</MenuItem>
                                        <MenuItem value="A2">A2</MenuItem>
                                        <MenuItem value="B1">B1</MenuItem>
                                        <MenuItem value="B2">B2</MenuItem>
                                        <MenuItem value="C1">C1</MenuItem>
                                    </TextField>

                                    <FormHelperText sx={{ color: '#d32f2f' }}>
                                        {props.LeadFormData.ddlGermanLevelErr}
                                    </FormHelperText>
                                </Grid>

                            )
                        }

                    </Grid>

                </CardContent>
            </Card>

            {/* APPLICATION DETAILS */}
            <Card sx={{ mb: 3, borderRadius: 3 }}>
                <CardContent>

                    <Typography
                        variant="h6"
                        sx={{
                            mb: 3,
                            color: '#042740',
                            fontWeight: 600
                        }}
                    >
                        Application Details
                    </Typography>

                    <Grid container spacing={2}>
                        {/* Student Referred By */}


                        <Grid item xs={12} md={4}>
                            <Autocomplete
                                options={props.mystate.instituteListData || []}
                                getOptionLabel={(option) => option.institute_name || ''}
                                value={
                                    props.mystate.instituteListData.find(
                                        item =>
                                            item.institute_name ===
                                            props.LeadFormData.txtStudentReferredBy
                                    ) || null
                                }
                                onChange={(event, newValue) => {
                                    props.HandleInputs(
                                        {
                                            target: {
                                                value: newValue?.institute_name || ''
                                            }
                                        },
                                        'txtStudentReferredBy'
                                    );
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Student Referred By"
                                        error={Boolean(
                                            props.LeadFormData.txtStudentReferredByErr
                                        )}
                                    />
                                )}
                            />

                            <FormHelperText sx={{ color: '#d32f2f' }}>
                                {props.LeadFormData.txtStudentReferredByErr}
                            </FormHelperText>
                        </Grid>
                        {/* <Grid item xs={12} md={4}>
                            <TextField
                                select
                                fullWidth
                                label="Student Referred By"
                                value={props.LeadFormData.txtStudentReferredBy || ''}
                                error={
                                    props.LeadFormData.txtStudentReferredByErr
                                        ? true
                                        : false
                                }
                                onChange={(e) =>
                                    props.HandleInputs(e, 'txtStudentReferredBy')
                                }
                            >
                                {
                                    props.mystate.instituteListData.length > 0 ?

                                        props.mystate.instituteListData.map((item, i) =>
                                            <MenuItem value={item.institute_name}>{item.institute_name}</MenuItem>
                                        )

                                        :
                                        null
                                }

                            </TextField>
                            <FormHelperText sx={{ color: '#d32f2f' }}>
                                {props.LeadFormData.txtStudentReferredByErr}
                            </FormHelperText>
                        </Grid> */}

                        {/* UPRN POC */}
                        <Grid item xs={12} md={4}>
                            <TextField
                                fullWidth
                                label="UPRN POC"
                                value={props.LeadFormData.txtUPRNPOC || ''}
                                error={props.LeadFormData.txtUPRNPOCErr ? true : false}
                                onChange={(e) =>
                                    props.HandleInputs(e, 'txtUPRNPOC')
                                }
                            />
                            <FormHelperText sx={{ color: '#d32f2f' }}>
                                {props.LeadFormData.txtUPRNPOCErr}
                            </FormHelperText>
                        </Grid>



                        {/* B2B Partner */}
                        <Grid item xs={12} md={4}>
                            <TextField
                                fullWidth
                                label="B2B Partner Name"
                                value={props.LeadFormData.txtB2BPartnerName || ''}
                                error={props.LeadFormData.txtB2BPartnerNameErr ? true : false}
                                onChange={(e) =>
                                    props.HandleInputs(e, 'txtB2BPartnerName')
                                }
                            />
                            <FormHelperText sx={{ color: '#d32f2f' }}>
                                {props.LeadFormData.txtB2BPartnerNameErr}
                            </FormHelperText>
                        </Grid>

                        {/* Application Status */}
                        <Grid item xs={12} md={4}>
                            <TextField
                                select
                                fullWidth
                                label="Application Status"
                                value={props.LeadFormData.ddlApplicationStatus || ''}
                                error={props.LeadFormData.ddlApplicationStatusErr ? true : false}
                                onChange={(e) =>
                                    props.HandleInputs(e, 'ddlApplicationStatus')
                                }
                            >
                                <MenuItem value="Preliminary Screening Done">
                                    Preliminary Screening Done
                                </MenuItem>

                                <MenuItem value="Language Screening Done">
                                    Language Screening Done
                                </MenuItem>

                                <MenuItem value="Resume Ready">
                                    Resume Ready
                                </MenuItem>

                                <MenuItem value="Interview With Agency">
                                    Interview With Agency
                                </MenuItem>

                                <MenuItem value="COL Issued">
                                    COL Issued
                                </MenuItem>

                                <MenuItem value="COL Accepted Agreement Done">
                                    COL Accepted, Agreement Done
                                </MenuItem>

                                <MenuItem value="Security Deposit Paid">
                                    Security Deposit Paid
                                </MenuItem>

                                <MenuItem value="Interviewing With Hospital">
                                    Interviewing With Hospital
                                </MenuItem>

                                <MenuItem value="Final Offer Issued">
                                    Final Offer Issued
                                </MenuItem>
                            </TextField>

                            <FormHelperText sx={{ color: '#d32f2f' }}>
                                {props.LeadFormData.ddlApplicationStatusErr}
                            </FormHelperText>
                        </Grid>

                        {/* German Agency */}
                        <Grid item xs={12} md={4}>
                            <TextField
                                fullWidth
                                label="German Agency Name"
                                value={props.LeadFormData.txtGermanAgencyName || ''}
                                error={props.LeadFormData.txtGermanAgencyNameErr ? true : false}
                                onChange={(e) =>
                                    props.HandleInputs(e, 'txtGermanAgencyName')
                                }
                            />
                            <FormHelperText sx={{ color: '#d32f2f' }}>
                                {props.LeadFormData.txtGermanAgencyNameErr}
                            </FormHelperText>
                        </Grid>

                        {/* Employer Name */}
                        <Grid item xs={12} md={4}>
                            <TextField
                                fullWidth
                                label="Employer Name"
                                value={props.LeadFormData.txtEmployerName || ''}
                                error={props.LeadFormData.txtEmployerNameErr ? true : false}
                                onChange={(e) =>
                                    props.HandleInputs(e, 'txtEmployerName')
                                }
                            />
                            <FormHelperText sx={{ color: '#d32f2f' }}>
                                {props.LeadFormData.txtEmployerNameErr}
                            </FormHelperText>
                        </Grid>

                        {/* Job Location */}
                        <Grid item xs={12} md={4}>
                            <TextField
                                fullWidth
                                label="Job Location"
                                value={props.LeadFormData.txtJobLocation || ''}
                                error={props.LeadFormData.txtJobLocationErr ? true : false}
                                onChange={(e) =>
                                    props.HandleInputs(e, 'txtJobLocation')
                                }
                            />
                            <FormHelperText sx={{ color: '#d32f2f' }}>
                                {props.LeadFormData.txtJobLocationErr}
                            </FormHelperText>
                        </Grid>

                        {/* Salary Offered */}
                        <Grid item xs={12} md={4}>
                            <TextField
                                fullWidth
                                label="Salary Offered (Gross)"
                                value={props.LeadFormData.txtSalaryOffered || ''}
                                error={props.LeadFormData.txtSalaryOfferedErr ? true : false}
                                onChange={(e) =>
                                    props.HandleInputs(e, 'txtSalaryOffered')
                                }
                            />
                            <FormHelperText sx={{ color: '#d32f2f' }}>
                                {props.LeadFormData.txtSalaryOfferedErr}
                            </FormHelperText>
                        </Grid>

                        {/* Employer Type */}
                        <Grid item xs={12} md={4}>
                            <TextField
                                select
                                fullWidth
                                label="Employer Type"
                                value={props.LeadFormData.ddlEmployerType || ''}
                                error={props.LeadFormData.ddlEmployerTypeErr ? true : false}
                                onChange={(e) =>
                                    props.HandleInputs(e, 'ddlEmployerType')
                                }
                            >
                                <MenuItem value="Govt Hospital">Govt Hospital</MenuItem>
                                <MenuItem value="Church Hospital">Church Hospital</MenuItem>
                                <MenuItem value="Private Hospital">Private Hospital</MenuItem>
                                <MenuItem value="University Hospital">University Hospital</MenuItem>
                                <MenuItem value="Senior Care Home">Senior Care Home</MenuItem>
                                <MenuItem value="Mobile Van">Mobile Van</MenuItem>
                            </TextField>

                            <FormHelperText sx={{ color: '#d32f2f' }}>
                                {props.LeadFormData.ddlEmployerTypeErr}
                            </FormHelperText>
                        </Grid>

                        {/* Tentative Joining */}
                        <Grid item xs={12} md={4}>
                            <TextField
                                type="date"
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                label="Tentative Joining"
                                value={props.LeadFormData.txtTentativeJoining || ''}
                                error={props.LeadFormData.txtTentativeJoiningErr ? true : false}
                                onChange={(e) =>
                                    props.HandleInputs(e, 'txtTentativeJoining')
                                }
                            />
                            <FormHelperText sx={{ color: '#d32f2f' }}>
                                {props.LeadFormData.txtTentativeJoiningErr}
                            </FormHelperText>
                        </Grid>

                        {/* Finishing School Status */}
                        <Grid item xs={12} md={4}>
                            <TextField
                                select
                                fullWidth
                                label="Finishing School Status"
                                value={props.LeadFormData.ddlFinishingSchoolStatus || ''}
                                error={props.LeadFormData.ddlFinishingSchoolStatusErr ? true : false}
                                onChange={(e) =>
                                    props.HandleInputs(e, 'ddlFinishingSchoolStatus')
                                }
                            >
                                <MenuItem value="B2 Pursuing">
                                    B2 Pursuing
                                </MenuItem>

                                <MenuItem value="B2 Certified">
                                    B2 Certified
                                </MenuItem>

                                <MenuItem value="Interview Training">
                                    Interview Training
                                </MenuItem>

                                <MenuItem value="Conversation Classes">
                                    Conversation Classes / Advance B2 Speaking
                                </MenuItem>
                            </TextField>

                            <FormHelperText sx={{ color: '#d32f2f' }}>
                                {props.LeadFormData.ddlFinishingSchoolStatusErr}
                            </FormHelperText>
                        </Grid>

                    </Grid>

                </CardContent>
            </Card>

            {/* DOCUMENT CHECKLIST */}
            <Card sx={{ mb: 3, borderRadius: 3 }}>
                <CardContent>

                    <Typography
                        variant="h6"
                        sx={{
                            mb: 3,
                            color: '#042740',
                            fontWeight: 600
                        }}
                    >
                        Documents Available
                    </Typography>

                    <Grid container spacing={1}>

                        <Grid item xs={12} md={6}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={props.LeadFormData.chkBirthCertificate === true ? true : false}
                                        onChange={(e) =>
                                            props.HandleCheckBox(
                                                e,
                                                'chkBirthCertificate'
                                            )
                                        }
                                    />
                                }
                                label="Birth Certificate"
                            />
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={props.LeadFormData.chkBirthCertificate === true ? true : false}
                                        checked={props.LeadFormData.chkTenthMarksheet}
                                        onChange={(e) =>
                                            props.HandleCheckBox(
                                                e,
                                                'chkTenthMarksheet'
                                            )
                                        }
                                    />
                                }
                                label="10th Marksheet"
                            />
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={props.LeadFormData.chkBirthCertificate === true ? true : false}
                                        checked={props.LeadFormData.chkTwelfthMarksheet}
                                        onChange={(e) =>
                                            props.HandleCheckBox(
                                                e,
                                                'chkTwelfthMarksheet'
                                            )
                                        }
                                    />
                                }
                                label="12th Marksheet"
                            />
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={props.LeadFormData.chkBirthCertificate === true ? true : false}
                                        checked={props.LeadFormData.chkNursingCertificate}
                                        onChange={(e) =>
                                            props.HandleCheckBox(
                                                e,
                                                'chkNursingCertificate'
                                            )
                                        }
                                    />
                                }
                                label="Nursing Certificate"
                            />
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={props.LeadFormData.chkTranscriptOfRecords === true ? true : false}

                                        onChange={(e) =>
                                            props.HandleCheckBox(
                                                e,
                                                'chkTranscriptOfRecords'
                                            )
                                        }
                                    />
                                }
                                label="Transcript Of Records"
                            />
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={props.LeadFormData.chkNursingMarksheetAllSemesters === true ? true : false}

                                        onChange={(e) =>
                                            props.HandleCheckBox(
                                                e,
                                                'chkNursingMarksheetAllSemesters'
                                            )
                                        }
                                    />
                                }
                                label="Nursing Marksheet (All Semesters)"
                            />
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={props.LeadFormData.chkActiveNursingCouncilRegistration === true ? true : false}

                                        onChange={(e) =>
                                            props.HandleCheckBox(
                                                e,
                                                'chkActiveNursingCouncilRegistration'
                                            )
                                        }
                                    />
                                }
                                label="Active Nursing Council Registration"
                            />
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={props.LeadFormData.chkPassport === true ? true : false}

                                        onChange={(e) =>
                                            props.HandleCheckBox(
                                                e,
                                                'chkPassport'
                                            )
                                        }
                                    />
                                }
                                label="Passport"
                            />
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={props.LeadFormData.chkProfessionalShotPhoto === true ? true : false}

                                        onChange={(e) =>
                                            props.HandleCheckBox(
                                                e,
                                                'chkProfessionalShotPhoto'
                                            )
                                        }
                                    />
                                }
                                label="Professional Shot Photo"
                            />
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={props.LeadFormData.chkMarriageCertificate === true ? true : false}

                                        onChange={(e) =>
                                            props.HandleCheckBox(
                                                e,
                                                'chkMarriageCertificate'
                                            )
                                        }
                                    />
                                }
                                label="Marriage Certificate"
                            />
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={props.LeadFormData.chkGermanResume === true ? true : false}

                                        onChange={(e) =>
                                            props.HandleCheckBox(
                                                e,
                                                'chkGermanResume'
                                            )
                                        }
                                    />
                                }
                                label="German Resume"
                            />
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={props.LeadFormData.chkGoodStandingCertificate === true ? true : false}

                                        onChange={(e) =>
                                            props.HandleCheckBox(
                                                e,
                                                'chkGoodStandingCertificate'
                                            )
                                        }
                                    />
                                }
                                label="Good Standing Certificate"
                            />
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={props.LeadFormData.chkPoliceClearanceCertificate === true ? true : false}

                                        onChange={(e) =>
                                            props.HandleCheckBox(
                                                e,
                                                'chkPoliceClearanceCertificate'
                                            )
                                        }
                                    />
                                }
                                label="Police Clearance Certificate"
                            />
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={props.LeadFormData.chkVaccination === true ? true : false}

                                        onChange={(e) =>
                                            props.HandleCheckBox(
                                                e,
                                                'chkVaccination'
                                            )
                                        }
                                    />
                                }
                                label="Vaccination"
                            />
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={props.LeadFormData.chkB1GermanCertificate === true ? true : false}

                                        onChange={(e) =>
                                            props.HandleCheckBox(
                                                e,
                                                'chkB1GermanCertificate'
                                            )
                                        }
                                    />
                                }
                                label="B1 German Certificate"
                            />
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={props.LeadFormData.chkB2GermanCertificate === true ? true : false}

                                        onChange={(e) =>
                                            props.HandleCheckBox(
                                                e,
                                                'chkB2GermanCertificate'
                                            )
                                        }
                                    />
                                }
                                label="B2 German Certificate"
                            />
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={props.LeadFormData.chkExperienceLetter === true ? true : false}

                                        onChange={(e) =>
                                            props.HandleCheckBox(
                                                e,
                                                'chkExperienceLetter'
                                            )
                                        }
                                    />
                                }
                                label="Experience Letter"
                            />
                        </Grid>

                    </Grid>

                </CardContent>
            </Card>

            {/* RECOGNITION & DEPLOYMENT */}
            <Card sx={{ mb: 3, borderRadius: 3 }}>
                <CardContent>

                    <Typography
                        variant="h6"
                        sx={{
                            mb: 3,
                            color: '#042740',
                            fontWeight: 600
                        }}
                    >
                        6. Recognition & Deployment
                    </Typography>

                    <Grid container spacing={2}>

                        {/* Applied for Recognition */}
                        <Grid item xs={12} md={4}>
                            <TextField
                                select
                                fullWidth
                                label="Applied for Recognition / Defizit Before?"
                                value={
                                    props.LeadFormData.ddlAppliedRecognition || ''
                                }
                                error={
                                    props.LeadFormData.ddlAppliedRecognitionErr
                                        ? true
                                        : false
                                }
                                onChange={(e) =>
                                    props.HandleInputs(
                                        e,
                                        'ddlAppliedRecognition'
                                    )
                                }
                            >
                                <MenuItem value="Yes">Yes</MenuItem>
                                <MenuItem value="No">No</MenuItem>
                            </TextField>

                            <FormHelperText sx={{ color: '#d32f2f' }}>
                                {props.LeadFormData.ddlAppliedRecognitionErr}
                            </FormHelperText>
                        </Grid>

                        {/* Recognition Status */}
                        <Grid item xs={12} md={4}>
                            <TextField
                                select
                                fullWidth
                                label="Recognition / Defizit Status"
                                value={
                                    props.LeadFormData.ddlRecognitionStatus || ''
                                }
                                error={
                                    props.LeadFormData.ddlRecognitionStatusErr
                                        ? true
                                        : false
                                }
                                onChange={(e) =>
                                    props.HandleInputs(
                                        e,
                                        'ddlRecognitionStatus'
                                    )
                                }
                            >
                                <MenuItem value="Pending">
                                    Pending
                                </MenuItem>

                                <MenuItem value="Applied">
                                    Applied
                                </MenuItem>

                                <MenuItem value="Issued">
                                    Issued
                                </MenuItem>
                            </TextField>

                            <FormHelperText sx={{ color: '#d32f2f' }}>
                                {props.LeadFormData.ddlRecognitionStatusErr}
                            </FormHelperText>
                        </Grid>

                        {/* Deployment Status */}
                        <Grid item xs={12} md={4}>
                            <TextField
                                select
                                fullWidth
                                label="Deployment Status"
                                value={
                                    props.LeadFormData.ddlDeploymentStatus || ''
                                }
                                error={
                                    props.LeadFormData.ddlDeploymentStatusErr
                                        ? true
                                        : false
                                }
                                onChange={(e) =>
                                    props.HandleInputs(
                                        e,
                                        'ddlDeploymentStatus'
                                    )
                                }
                            >
                                <MenuItem value="Visa Applied">
                                    Visa Applied
                                </MenuItem>

                                <MenuItem value="Visa Issued">
                                    Visa Issued
                                </MenuItem>

                                <MenuItem value="Tickets Booked">
                                    Tickets Booked
                                </MenuItem>

                                <MenuItem value="Landed in Germany">
                                    Landed in Germany
                                </MenuItem>
                            </TextField>

                            <FormHelperText sx={{ color: '#d32f2f' }}>
                                {props.LeadFormData.ddlDeploymentStatusErr}
                            </FormHelperText>
                        </Grid>

                    </Grid>

                </CardContent>
            </Card>


            {
                props.mystate.mode === 'edit' ?
                    <Card sx={{ mb: 3, borderRadius: 3 }}>
                        <CardContent>

                            <Grid container>
                                <Grid xs={6} md={6} mt={5} id="description">
                                    <Box p={1}>
                                        <Typography className='grey-theme-btn' fontWeight={'bold'} variant="h6" component="h6">
                                            Comments
                                        </Typography>
                                    </Box>
                                </Grid>
                                <Grid xs={6} md={6} mt={5}>
                                    {
                                        props.mystate.userData.profile !== 'Marketing' ?
                                            <Box p={1} textAlign={'right'}>
                                                <Button className='grey-theme-btn' variant="outlined" onClick={() => props.ToggleDescriptionBox()}>Add New</Button>
                                            </Box>
                                            :
                                            null
                                    }
                                </Grid>

                                <Grid xs={12} md={12}>
                                    <Box p={1}>
                                        <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                                            <TableContainer sx={{ maxHeight: '200px' }}>
                                                <Table stickyHeader aria-label="sticky table">
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell
                                                                key={'SrNo'}
                                                                align={'left'}
                                                                width={50}
                                                                className='table-head-cell'
                                                            >
                                                                {'SrNo'}
                                                            </TableCell>
                                                            <TableCell
                                                                key={'Added On'}
                                                                align={'left'}
                                                                width={100}
                                                                className='table-head-cell'
                                                            >
                                                                {'Added On'}
                                                            </TableCell>
                                                            <TableCell
                                                                key={'Added By'}
                                                                align={'left'}
                                                                width={100}
                                                                className='table-head-cell'
                                                            >
                                                                {'Added By'}
                                                            </TableCell>
                                                            <TableCell
                                                                key={'Comment'}
                                                                align={'left'}
                                                                width={150}
                                                                className='table-head-cell'
                                                            >
                                                                {'Comment'}
                                                            </TableCell>



                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {props.mystate.leadDetails != undefined && props.mystate.leadDetails.length > 0 && props.mystate.leadDetails[0].comment_array && props.mystate.leadDetails[0].comment_array.length > 0 ?
                                                            props.mystate.leadDetails[0].comment_array.map((item, i) => (
                                                                <TableRow hover role="checkbox" tabIndex={-1} key={i}>
                                                                    <TableCell key={i + 1} align={'left'}>
                                                                        {i + 1}
                                                                    </TableCell>
                                                                    <TableCell key={item.Date + i} align={'left'}>
                                                                        {item.Date}
                                                                    </TableCell>
                                                                    <TableCell key={item["Added By"] + i} align={'left'}>
                                                                        {item["Added By"]} <br></br> <strong>{item["Added By Profile"]}</strong>
                                                                    </TableCell>
                                                                    <TableCell key={item.Comment + i} align={'left'}>
                                                                        <span>{item.Comment}</span>
                                                                    </TableCell>

                                                                </TableRow>
                                                            ))
                                                            : ''
                                                        }
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </Paper>
                                    </Box>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card >
                    :
                    null
            }

            <Modal
                open={props.mystate.openDescriptionBox}
                onClose={() => props.ToggleDescriptionBox()}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Typography className='grey-theme-btn' variant="h6" component="h2">
                        Add Comment
                    </Typography>
                    <Box mt={1}>
                        <TextField multiline rows={4} className="text-input" id="txtLeadComment" name='txtLeadComment' error={props.LeadFormData.txtLeadCommentErr == undefined || props.LeadFormData.txtLeadCommentErr == '' ? false : true} helperText={props.LeadFormData.txtLeadCommentErr} onChange={(e) => props.HandleInputs(e, 'txtLeadComment')} value={props.LeadFormData.txtLeadComment || ''} label="Enter Your Comment" variant="outlined" />
                        <FormHelperText style={{ fontSize: 10, textAlign: 'end', color: '#042740', fontWeight: 'bold' }}>{'Max Char. 60'}</FormHelperText>
                    </Box>
                    <Box mt={2}>
                        <Grid container>
                            <Grid sx={6}>
                                <Button className='grey-theme-btn' variant="outlined" onClick={() => props.AddDescription()}>Add</Button>
                            </Grid>
                            <Grid sx={6} ml={2}>
                                <Button className='grey-theme-btn' variant="outlined" onClick={() => props.ToggleDescriptionBox()}>Cancel</Button>
                            </Grid>
                        </Grid>
                    </Box>

                </Box>
            </Modal>

            {/* SAVE BUTTON */}
            < Grid container >
                <Grid item xs={12}>
                    <Box textAlign={'center'} m={3}>

                        {
                            props.mystate.mode === 'add' ?

                                props.LeadFormData.addUser === true ?

                                    <LoadingButton
                                        loading
                                        loadingPosition="start"
                                        startIcon={<SaveIcon />}
                                        variant="contained"
                                    >
                                        Save Student
                                    </LoadingButton>

                                    :

                                    <Button
                                        variant="contained"
                                        className='grey-theme-btn'
                                        onClick={() => props.SaveOrUpdateLead()}
                                    >
                                        Save Student
                                    </Button>

                                :

                                props.LeadFormData.editUser === true ?

                                    <LoadingButton
                                        loading
                                        loadingPosition="start"
                                        startIcon={<SaveIcon />}
                                        variant="contained"
                                    >
                                        Update Student
                                    </LoadingButton>

                                    :

                                    <Button
                                        variant="contained"
                                        className='grey-theme-btn'
                                        onClick={() => props.SaveOrUpdateLead()}
                                    >
                                        Update Student
                                    </Button>
                        }

                    </Box>
                </Grid>
            </Grid >

            {/* ALERT */}
            < Snackbar
                open={props.mystate.showAlert}
                autoHideDuration={3000}
                onClose={() => {
                    props.HandleCloseAlertMsg(props.mystate.alertType);
                }}
            >
                <Alert
                    onClose={() => {
                        props.HandleCloseAlertMsg(props.mystate.alertType);
                    }}
                    severity={props.mystate.alertType}
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    {props.mystate.alertMsg}
                </Alert>
            </Snackbar >

        </Box >
    );
};